import React from 'react';
import Report from '../Report';
import CompositeReport from '../CompositeReport';
import {t} from 'shared/core';

const filters = [
  'Completion Date',
  'Due Date',
  'Assignment Date',
  'Task Type',
  'Employee',
  'Department',
  'Location',
  'Manager'
];

const TasksReport = () => {
  return (
    <CompositeReport filters={filters}>
      <Report
        name={t('reports.TASKS')}
        url='/reports/tasks'
      />
    </CompositeReport>
  );
};

export default TasksReport;
